export default "__VITE_ASSET__94a0e404__"